import { AddSongStep, isAddSongStep } from 'fym-shared/src/music24/catalogAddSong';
import { SMLRouteNames } from '../../../../routing/sml/SMLRoutes';

/**
 * Where the flow came from. Close goes back there; `onboarding` also changes the Done step.
 * `coverMaker` is "Which song is this cover for?" (`/app/cover-maker/continue`): the cover step
 * then offers the carried design. `presave` is the song picker of the pre-save screen (design
 * presave-create c1): Close goes back to it, and Done leads with the pre-save card.
 */
export type AddSongFrom = 'catalog' | 'releases' | 'home' | 'studio' | 'onboarding' | 'coverMaker' | 'presave';

const FROM_VALUES: readonly AddSongFrom[] = [
  'catalog',
  'releases',
  'home',
  'studio',
  'onboarding',
  'coverMaker',
  'presave',
];

export function parseAddSongFrom(value: string | null | undefined): AddSongFrom {
  return FROM_VALUES.find((from) => from === value) ?? 'catalog';
}

export function parseAddSongStep(value: string | null | undefined): AddSongStep | undefined {
  return isAddSongStep(value) ? value : undefined;
}

interface CatalogAddSongPathOptions {
  /** The catalog row once step 1 saved it. */
  item?: string;
  step?: AddSongStep;
  from?: AddSongFrom;
  /** The artist of the row. The web switcher reads it (`resolveActiveAccountId.ts`). */
  accountId?: number | null;
}

/**
 * The path of the step-by-step "Add a song" page (design catalog-add-song a·why):
 * `/catalog/new[?item=<uuid>][&step=<step>][&from=<from>][&accountId=<id>]`. The router adds `/app`.
 * Onboarding runs the same steps on its own route: `from: 'onboarding'` gives `/addSong?…`.
 */
export function catalogAddSongPath(options: CatalogAddSongPathOptions = {}): string {
  const query = new URLSearchParams();
  if (options.item !== undefined && options.item !== '') {
    query.set('item', options.item);
  }
  if (options.step !== undefined) {
    query.set('step', options.step);
  }
  // The onboarding route is its own `from`.
  if (options.from !== undefined && options.from !== 'onboarding') {
    query.set('from', options.from);
  }
  if (options.accountId !== undefined && options.accountId !== null) {
    query.set('accountId', String(options.accountId));
  }
  const search = query.toString();
  const base = options.from === 'onboarding' ? `/${SMLRouteNames.addSong}` : `/${SMLRouteNames.catalog}/new`;
  return `${base}${search === '' ? '' : `?${search}`}`;
}
